<template>
  <div class="pfooter" >
    <div class="footerConter">
      <div class="footerTop">
        <div>
          <img v-lazy="hrefurl+'/public/footer_home/footerLogo.png'" alt="logo"/>
        </div>
        <div>
        <img v-lazy="hrefurl+'/public/footer_home/footerContact.png'" />
        </div>
      </div>
      <div class="footerBottom">
        <p><span style="font-family:Arial">Copyright © 2022 cippe.com.cn All Rights Reserved</span> 北京振威展览有限公司（证券代码： 834316）版权所有</p>
        <p ><span class="record" @click="webHerf('https://beian.miit.gov.cn')">京ICP备05086866号</span><span class="record" style="margin-left: 20px;" @click="webHerf('https://beian.miit.gov.cn')"><img style="width: 20px;height: 20px;" src="http://public.zhenweievents.com/images/jgw.png" alt=""> 京公网安备11010502053159号</span></p>
      </div>
    </div> 
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .pfooter{
    width: 100%;
    height: 200px;
    background-color: #373737;
  }
  .footerConter{
    width: 1200px;
    height: 200px;
    background-color: #373737;
    margin: 0 auto;
    /* background-color: tomato; */
  }
  .footerTop{
    display: flex;
    justify-content: space-between;
  }
  .footerTop>div{
    padding: 30px 0;
  }
  .footerBottom>p{
    font-size: 14px;
    color: whitesmoke;
    padding-bottom: 15px;
  }
  .record{
    cursor: pointer;
  }
  .record:hover{
    text-decoration: underline;
  }
</style>